import { OWNER_BG, OWNER_BORDER } from './ownerTheme'

const SkeletonBox = ({ className }: { className?: string }) => (
  <div className={`animate-pulse rounded-lg bg-white/10 ${className || ''}`} />
)

export default function OwnerConsoleSkeleton() {
  return (
    <div className="space-y-6 rounded-3xl border p-6" style={{ borderColor: OWNER_BORDER, backgroundColor: OWNER_BG }}>
      <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
        <div className="space-y-2">
          <SkeletonBox className="h-6 w-40" />
          <SkeletonBox className="h-4 w-64" />
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <SkeletonBox className="h-10 w-24" />
          <SkeletonBox className="h-10 w-28" />
          <SkeletonBox className="h-10 w-32" />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {Array.from({ length: 8 }).map((_, idx) => (
          <div key={idx} className="rounded-2xl border p-4" style={{ borderColor: OWNER_BORDER }}>
            <SkeletonBox className="h-3 w-24" />
            <SkeletonBox className="mt-4 h-6 w-20" />
            <SkeletonBox className="mt-4 h-3 w-32" />
          </div>
        ))}
      </div>

      <div className="rounded-2xl border p-5" style={{ borderColor: OWNER_BORDER }}>
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div className="space-y-2">
            <SkeletonBox className="h-3 w-20" />
            <SkeletonBox className="h-5 w-56" />
            <SkeletonBox className="h-4 w-32" />
          </div>
          <SkeletonBox className="h-16 w-full max-w-xs" />
        </div>
        <div className="mt-4 space-y-2">
          <SkeletonBox className="h-3 w-2/3" />
          <SkeletonBox className="h-3 w-1/2" />
        </div>
      </div>

      <div className="rounded-2xl border p-3" style={{ borderColor: OWNER_BORDER }}>
        <div className="grid grid-cols-1 gap-3 md:grid-cols-5">
          {Array.from({ length: 5 }).map((_, idx) => (
            <div key={idx} className="flex items-center gap-3">
              <SkeletonBox className="h-2.5 w-2.5 rounded-full" />
              <div className="space-y-1">
                <SkeletonBox className="h-3 w-20" />
                <SkeletonBox className="h-4 w-16" />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-2xl border p-2" style={{ borderColor: OWNER_BORDER }}>
        <div className="flex flex-wrap gap-2">
          {Array.from({ length: 6 }).map((_, idx) => (
            <SkeletonBox key={idx} className="h-9 w-24" />
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        <div className="rounded-2xl border p-4 lg:col-span-2" style={{ borderColor: OWNER_BORDER }}>
          <SkeletonBox className="h-4 w-40" />
          <SkeletonBox className="mt-2 h-3 w-24" />
          <SkeletonBox className="mt-6 h-32 w-full" />
        </div>
        <div className="grid gap-4">
          {Array.from({ length: 2 }).map((_, idx) => (
            <div key={idx} className="rounded-2xl border p-4" style={{ borderColor: OWNER_BORDER }}>
              <SkeletonBox className="h-3 w-24" />
              <SkeletonBox className="mt-4 h-6 w-20" />
              <SkeletonBox className="mt-4 h-3 w-28" />
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-2xl border p-4" style={{ borderColor: OWNER_BORDER }}>
        <SkeletonBox className="h-4 w-40" />
        <div className="mt-3 space-y-2">
          {Array.from({ length: 6 }).map((_, idx) => (
            <SkeletonBox key={idx} className="h-3 w-full" />
          ))}
        </div>
      </div>
    </div>
  )
}
